var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.$store.state.isCollapse ? 'container_collapse' : 'container',staticStyle:{"background-color":"#3C3C3C"}},[_c('el-row',{staticClass:"top-section"},[_c('video-player',{ref:"VideoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"options":_vm.playerOptions},on:{"ready":_vm.playerReadied}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }